import Button from '@/common/components/base/button/Button';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';

const OfflineShowPhotoInformationModal = ({
  closeModal,
  open,
  confirmButtonText,
}: MainModalProps & { confirmButtonText: string }) => {
  return (
    <MainModal closeModal={closeModal} open={open}>
      <OfflineShowPhotoInfo
        confirmButtonText={confirmButtonText}
        closeModal={closeModal}
      />
    </MainModal>
  );
};

const OfflineShowPhotoInfo = ({
  closeModal,
  confirmButtonText,
}: {
  closeModal: MainModalProps['closeModal'];
  confirmButtonText: string;
}) => {
  return (
    <>
      {' '}
      <TitleDescription>تصاویر آفلاین</TitleDescription>
      <Typography textStyle="b2" mt={24} color="black-1">
        کارشناس محترم، تصاویر در پرونده به صورت افلاین ثبت شده است و به دلیل
        تغییر دستگاه موبایل یا حذف شدن اطلاعات مرورگر امکان بازیابی تصاویر وجود
        ندارد. لطفا مجدد فرایند عکس برداری را انجام دهید.
      </Typography>
      <Button mt="1rem" onClick={closeModal} fullWidth>
        {confirmButtonText}
      </Button>
    </>
  );
};

export default OfflineShowPhotoInformationModal;
